import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";

export const ServiceSectorField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["3", "27", "35"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="serviceSector"
        fullWidth
        label={t(translationPath + "serviceSector") || "serviceSector"}
      />
      <FormHelperText>
        {t(translationPath + "serviceSectorMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
